class Top {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    function getCookie(name) {
      const value = `; ${document.cookie}`;
      const parts = value.split(`; ${name}=`);
      if (parts.length === 2) return parts.pop().split(';').shift();
      return null;
    }
    
    function setCookie(name, value, days) {
      const date = new Date();
      date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
      const expires = `expires=${date.toUTCString()}`;
      document.cookie = `${name}=${value}; ${expires}; path=/`;
    }
    

    if(!getCookie('animationPlayed')) {
      if (!location.hash) {
        setCookie("animationPlayed", "true", 1);
        const mvImg = document.querySelector('.js-mv-img');
        const header = document.querySelector('.js-header');
        const copy = document.querySelector('.js-copy');
        const subcopy = document.querySelector('.js-subcopy');
        const scroll = document.querySelector('.js-scroll');
        const encopy = document.querySelector('.js-copy-en');
  
        // 初期状態を設定
        gsap.set([mvImg, header, scroll], { opacity: 0 });
        gsap.set(subcopy, { opacity: 0, y: 5, visibility: 'hidden' });
  
        const wrapTextInSpans = (element) => {
          const nodes = Array.from(element.childNodes);
          nodes.forEach(node => {
            if (node.nodeType === 3) { // テキストノード
              const text = node.nodeValue;
              const wrappedText = text.split('').map(char => `<span>${char}</span>`).join('');
              const tempDiv = document.createElement('div');
              tempDiv.innerHTML = wrappedText;
              while (tempDiv.firstChild) {
                element.insertBefore(tempDiv.firstChild, node);
              }
              element.removeChild(node);
            } else if (node.nodeType === 1 && node.tagName === 'SPAN' && node.classList.contains('tracking-[-0.15em]')) {
            } else if (node.nodeType === 1 && node.tagName === 'BR') {
            } else if (node.nodeType === 1) { // 他の要素
              wrapTextInSpans(node);
            }
          });
        };
  
        wrapTextInSpans(copy);
        wrapTextInSpans(encopy);
        gsap.set(copy.querySelectorAll('span')[0], { textIndent: '-2.5rem' });
        gsap.set(copy.querySelectorAll('span'), { opacity: 0, y: 10 });
        gsap.set(encopy.querySelectorAll('span'), { opacity: 0, y: 10 }); 
  
        const timeline = gsap.timeline({
          scrollTrigger: {
            trigger: copy,
            start: 'top 80%',
          }
        });
      
          timeline
          .to(encopy.querySelectorAll('span'), {
            opacity: 1,
            y: 0,
            duration: 0.3,
            stagger: 0.1,
            ease: 'power2.out'
          })
          .to(copy.querySelectorAll('span'), {
            opacity: 1,
            y: 0,
            duration: 0.3,
            stagger: 0.1,
            ease: 'power2.out'
          })
          .to(subcopy, {
            opacity: 1,
            y: 0,
            duration: 1,
            ease: 'power2.out',
            visibility: 'visible'
          }, "-=0.3") // 前のアニメーションの終わりに重なるようにする
          .to(mvImg, {
            opacity: 1,
            duration: 1
          })
          .to(header, {
            opacity: 1,
            duration: 1
          })
          .to('.js-scroll', {
            opacity: 1,
            duration: 1 // ゆっくり表示
          }, "-=1");
  
        var svg1 = document.querySelector("#svg1");
        var path1 = svg1.querySelector('path');
        var svg2 = document.querySelector("#svg2");
        var path2 = svg2.querySelector('path');
        var svg3 = document.querySelector("#svg3");
        var path3 = svg3.querySelector('path');
        var svg4 = document.querySelector("#svg4");
        var path4 = svg4.querySelector('path');
      
        // Initialize the path lengths
        var path1Length = path1.getTotalLength();
        path1.style.strokeDasharray = path1Length;
        path1.style.strokeDashoffset = path1Length;
      
        var path2Length = path2.getTotalLength();
        path2.style.strokeDasharray = path2Length;
        path2.style.strokeDashoffset = path2Length;
  
        var path3Length = path3.getTotalLength();
        path3.style.strokeDasharray = path3Length;
        path3.style.strokeDashoffset = path3Length;
  
        var path4Length = path4.getTotalLength();
        path4.style.strokeDasharray = path4Length;
        path4.style.strokeDashoffset = path4Length;
  
      
        // Create a timeline
        var tl = gsap.timeline({
          scrollTrigger: {
            trigger: ".js-root-trigger",
            start: "top center",
            end: "bottom center",
          }
        });
      
        // Add the first SVG animation to the timeline
        tl.to(path1, {
          strokeDashoffset: 0,
          duration: 2,
          ease: "linear"
        });
      
        // Add the second SVG animation to the timeline, starting after the first one finishes
        tl.to(path2, {
          strokeDashoffset: 0,
          duration: 2,
          ease: "linear"
        }, "+=0");
  
        var tl2 = gsap.timeline({
          scrollTrigger: {
            trigger: ".js-root-trigger02",
            start: "top center",
            end: "bottom center",
          }
        });
  
        tl2.to(path3, {
          strokeDashoffset: 0,
          duration: 5,
          ease: "linear"
        });
  
        var tl3 = gsap.timeline({
          scrollTrigger: {
            trigger: ".js-root-trigger03",
            start: "top center",
            end: "bottom center",
          }
        });
  
        tl3.to(path4, {
          strokeDashoffset: 0,
          duration: 10,
          ease: "linear"
        });
  
  
        var svg5 = document.querySelector("#svg5");
        var path5 = svg5.querySelector('path');
        var svg6 = document.querySelector("#svg6");
        var path6 = svg6.querySelector('path');
  
  
        var path5Length = path5.getTotalLength();
        path5.style.strokeDasharray = path5Length;
        path5.style.strokeDashoffset = path5Length;
        var path6Length = path6.getTotalLength();
        path6.style.strokeDasharray = path6Length;
        path6.style.strokeDashoffset = path6Length;
  
        var mm = gsap.matchMedia();
  
        mm.add("(max-width: 767px)", () => {
          var tl5 = gsap.timeline({
            scrollTrigger: {
              trigger: ".js-root-trigger",
              start: "top center",
              end: "bottom center",
            }
          });
  
          tl5.to(path5, {
            strokeDashoffset: 0,
            duration: 2,
            ease: "linear"
          });
          tl5.to(path6, {
            strokeDashoffset: 0,
            duration: 5,
            ease: "linear"
          }, "+=0");
          
        });
  
        // タイトルエリア
        const titles = document.querySelectorAll('.c-ttl01');
  
        titles.forEach(title => {
          let splitText = title.innerHTML.split(/(<br\s*\/?>|<br\s+class=["']sp["']\s*\/?>|<br\s+class=["']pc["']\s*\/?>)/g);
          title.innerHTML = '';
        
          splitText.forEach(char => {
            if (char.match(/<br\s*\/?>|<br\s+class=["']sp["']\s*\/?>|<br\s+class=["']pc["']\s*\/?>/)) {
              let brTag = document.createElement('div');
              brTag.innerHTML = char;
              title.appendChild(brTag.firstChild);
            } else {
              char.split('').forEach(letter => {
                let span = document.createElement('span');
                span.textContent = letter;
                title.appendChild(span);
              });
            }
          });
        
          gsap.set(title.querySelectorAll('span'), {
            opacity: 0,
            y: 20,
          });
        
          ScrollTrigger.create({
            trigger: title,
            start: 'top 80%',
            onEnter: () => {
              gsap.to(title.querySelectorAll('span'), {
                opacity: 1,
                y: 0,
                duration: 0.5,
                stagger: 0.1,
                ease: 'power2.out',
              });
            },
          });
        });
      }
    }

  }
}